import React from 'react';
import { Tooltip, Button, useTooltip } from '@vtblife/uikit';

import { ButtonTwoState } from '../FavoritesButton/ButtonTwoState';
import { ReportModal } from './ReportModal';

const ReportButton = ({
    offerId,
    isMobile = false,
    isClSnippet = false
}: {
    offerId: string;
    isMobile?: boolean;
    isClSnippet?: boolean;
}) => {
    const [ isOpenModal, setIsOpenModal ] = React.useState(false);

    const handleOpenModal = React.useCallback(() => setIsOpenModal(true), []);
    const handleCloseModal = React.useCallback(() => setIsOpenModal(false), []);

    const { to, registerControl } = useTooltip();

    if (isClSnippet) {
        return (
            <>
                <ButtonTwoState
                    size='s'
                    variant='transparent-alt-bg'
                    fullWidth
                    icon='exclamation-triangle'
                    onClick={handleOpenModal}
                    tooltipText='Пожаловаться'
                    paddingSize='m'
                    circle
                    block
                    dataTest='offer-report-button'
                />
                {isOpenModal && (
                    <ReportModal
                        isMobile={isMobile}
                        offerId={offerId}
                        handleCloseModal={handleCloseModal}
                    />
                )}
            </>
        );
    }

    return (
        <>
            {isMobile ? (
                <ButtonTwoState
                    size='s'
                    variant='transparent-alt-bg'
                    fullWidth
                    icon='exclamation-triangle'
                    onClick={handleOpenModal}
                    dataTest='offer-report-button'
                >
                    Пожаловаться
                </ButtonTwoState>
            ) : (
                <div ref={registerControl}>
                    <Button
                        size='s'
                        variant='secondary'
                        fullWidth
                        disabled={isOpenModal}
                        onClick={handleOpenModal}
                        icon='exclamation-triangle'
                        dataTest='offer-report-button'
                    />
                    <Tooltip
                        direction='up'
                        to={to}
                    >
                        Пожаловаться
                    </Tooltip>
                </div>
            )}
            {isOpenModal && (
                <ReportModal
                    isMobile={isMobile}
                    offerId={offerId}
                    handleCloseModal={handleCloseModal}
                />
            )}
        </>
    );
};

export default ReportButton;
